<template>
  <div id="enjoy-mora">
    <header-section :title='"Gia nhập mạng lưới MoraNow"'></header-section>    
    <enjoy-mora-content></enjoy-mora-content>
  </div>    
</template>
<script>
  import EnjoyMoraContent from "./components/EnjoyMora/EnjoyMoraContent.vue";
  import HeaderSection from "./components/Common/HeaderSection.vue";
  export default{
    components:{
      HeaderSection,
      EnjoyMoraContent
    }
  };
</script>


// WEBPACK FOOTER //
// src/views/EnjoyMora.vue